import React, { useState, useEffect } from 'react';
import { Box, Typography, Drawer, IconButton, Button  } from '@mui/material';

import { useMediaQuery } from "@mui/material";

import { collection, onSnapshot, doc, getDocs,setDoc, writeBatch, deleteDoc, updateDoc, addDoc, query, where } from 'firebase/firestore';
import {db} from '../../firebaseConfig';

import CloseIcon from '@mui/icons-material/Close';

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import EditIcon from '@mui/icons-material/EditOutlined';

import PdfThumbnail from '../../images/PdfThumbnail.png'; // import a component or image for PDF thumbnail
import GenericFileThumbnail from '../../images/GenericFileThumbnail.png'; // import a component or image for generic file thumbnail

import { useTheme } from "@mui/material";

import { tokens } from "../../theme";

import { useUser } from "../../common/UserContext";
import { useApplicationMode } from "../../common/ApplicationModeContext";


const generateStatusColorMapDrawer = (applicationLifecycleManagements,theme) => {
  
        const statusColorMap = {};
        
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;

        applicationLifecycleManagements.forEach(applicationLifecycleManagement => {
          if (!statusColorMap[applicationLifecycleManagement.status]) {
            statusColorMap[applicationLifecycleManagement.status] = colorFunction(applicationLifecycleManagement.status);
          }
        });
      
        return statusColorMap;
      };
      

    const generateAssociatedRequirementIdsColorMapDrawer = (applicationLifecycleManagements, AssociatedRequirementIdsMap,theme) => {
        const associatedRequirementIdsColorMap = {};
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
        applicationLifecycleManagements.forEach(applicationLifecycleManagement => {
          (applicationLifecycleManagement.associatedRequirementIds || []).forEach(itemId => {
            const item = AssociatedRequirementIdsMap[itemId];
            if (item && !associatedRequirementIdsColorMap[item]) {
                associatedRequirementIdsColorMap[item] = colorFunction(item);
            }
          });
        });
        return associatedRequirementIdsColorMap;
      };
      


const stringToColorLight = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    // Ensuring that the color values are always light by adding a base value of 127
    const lightValue = ((value + 127) % 128) + 127;
    color += ('00' + lightValue.toString(16)).substr(-2);
  }
  return color;
};


const stringToColorDark = (str) => {
  
  return stringToColorLight(str); // We will use the same colors
};


const ApplicationLifecycleManagementDrawerModal = ({ drawerOpen, handleDrawerClose,handleArrowUpClick,handleArrowDownClick, selectedApplicationLifecycleManagement, applicationLifecycleManagements, handleOpenEdit }) => {

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const { appUserAccountNumber } = useUser();
  const { applicationMode } = useApplicationMode();
    
  const data = selectedApplicationLifecycleManagement;

  const [projectMap, setProjectMap] = useState({});
const [associatedRequirementIdsMap, setAssociatedRequirementIdsMap] = useState({});
const [associatedTestCaseIdsMap, setAssociatedTestCaseIdsMap] = useState({});
const [associatedTestRunIdsMap, setAssociatedTestRunIdsMap] = useState({});
const [associatedCodeReviewIdsMap, setAssociatedCodeReviewIdsMap] = useState({});

  
  
                const formatProject = value => {

                    let formattedProject = "";

                    if (value != null && value !=="")
                    {
                    formattedProject = projectMap[value];
                    }
                    
                    return formattedProject;
                };
    
                

                const formatAssociatedRequirementIds = value => {

                    let formattedAssociatedRequirementIds = "";

                    if (value != null)
                    {
                    formattedAssociatedRequirementIds = (value|| []).map(id => associatedRequirementIdsMap[id]).join(', ') || '';
                    }
                    
                    return formattedAssociatedRequirementIds;
                };
                              
                

                const formatAssociatedTestCaseIds = value => {

                    let formattedAssociatedTestCaseIds = "";

                    if (value != null)
                    {
                    formattedAssociatedTestCaseIds = (value|| []).map(id => associatedTestCaseIdsMap[id]).join(', ') || '';
                    }
                    
                    return formattedAssociatedTestCaseIds;
                };
                              
                

                const formatAssociatedTestRunIds = value => {

                    let formattedAssociatedTestRunIds = "";

                    if (value != null)
                    {
                    formattedAssociatedTestRunIds = (value|| []).map(id => associatedTestRunIdsMap[id]).join(', ') || '';
                    }
                    
                    return formattedAssociatedTestRunIds;
                };
                              
                

                const formatAssociatedCodeReviewIds = value => {

                    let formattedAssociatedCodeReviewIds = "";

                    if (value != null)
                    {
                    formattedAssociatedCodeReviewIds = (value|| []).map(id => associatedCodeReviewIdsMap[id]).join(', ') || '';
                    }
                    
                    return formattedAssociatedCodeReviewIds;
                };
                              
                

  
  
    useEffect(() => {
        const fetchStaticData = async () => {
            	const projectSnapshot = await getDocs(query(collection(db, "projects"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const projectData = projectSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const projectMap = projectData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.name }), {});
	setProjectMap(projectMap);

	const associatedRequirementIdsSnapshot = await getDocs(query(collection(db, "requirements"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const associatedRequirementIdsData = associatedRequirementIdsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const associatedRequirementIdsMap = associatedRequirementIdsData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.title }), {});
	setAssociatedRequirementIdsMap(associatedRequirementIdsMap);

	const associatedTestCaseIdsSnapshot = await getDocs(query(collection(db, "testCases"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const associatedTestCaseIdsData = associatedTestCaseIdsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const associatedTestCaseIdsMap = associatedTestCaseIdsData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.title }), {});
	setAssociatedTestCaseIdsMap(associatedTestCaseIdsMap);

	const associatedTestRunIdsSnapshot = await getDocs(query(collection(db, "testRuns"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const associatedTestRunIdsData = associatedTestRunIdsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const associatedTestRunIdsMap = associatedTestRunIdsData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.title }), {});
	setAssociatedTestRunIdsMap(associatedTestRunIdsMap);

	const associatedCodeReviewIdsSnapshot = await getDocs(query(collection(db, "codeReviews"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const associatedCodeReviewIdsData = associatedCodeReviewIdsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const associatedCodeReviewIdsMap = associatedCodeReviewIdsData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.title }), {});
	setAssociatedCodeReviewIdsMap(associatedCodeReviewIdsMap);



        };

        fetchStaticData();
      }, []);
    
    

  const [statusColorMap, setStatusColorMap] = useState({});
const [associatedRequirementIdsColorMap, setAssociatedRequirementIdsColorMap] = useState({});


//USE EFFECT TO CHANGE COLOR MAP when it changes
useEffect(() => {
  setStatusColorMap(generateStatusColorMapDrawer(applicationLifecycleManagements,theme));
setAssociatedRequirementIdsColorMap(generateAssociatedRequirementIdsColorMapDrawer(applicationLifecycleManagements, associatedRequirementIdsMap,theme));

}, [theme.palette.mode, drawerOpen, applicationLifecycleManagements ,associatedRequirementIdsMap]);


  const formatFirestoreDate = timestamp => {

    if (timestamp != null && timestamp !== "")
    {
      const dateStr = new Date(timestamp.seconds * 1000).toISOString().slice(0, 10);
      const parts = dateStr.split('-');
      return `${parts[1]}/${parts[2]}/${parts[0]}`;
    } else 
    {
      return "";
    }
  };

  const formatFirestoreTime = timestamp => {

   if (timestamp != null && timestamp !== "")
   { 
        // Convert the seconds since Unix epoch to a Date object
      const date = new Date(timestamp.seconds * 1000);

      // Extract hours and minutes
      let hours = date.getHours();
      const minutes = date.getMinutes();

      // Determine AM or PM
      const period = hours >= 12 ? 'PM' : 'AM';

      // Convert hours to 12-hour format
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'

      // Format hours and minutes as a time string in "hh:mm AM/PM" format
      const formattedHours = hours.toString().padStart(2, '0');
      const formattedMinutes = minutes.toString().padStart(2, '0');

      return `${formattedHours}:${formattedMinutes} ${period}`;
   } else
   {
    return "";
   }
  };


  const formatPhoneNumber = value => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };

  const formatCurrencyInteger = value => {
  
    if (value != null && value !=="")
    {
      return `$${Number(value).toLocaleString()}`;
    } else 
    {
      return "";
    }
  };

  const formatCurrency = (value) => {

    if (value != null && value !=="")
    {
          value = value.toString();
          // Remove all non-numeric characters except for the decimal point
          let result = value.replace(/[^0-9.]/g, '');
        
          // If there are multiple decimal points, keep only the first one
          const parts = result.split('.');
          if (parts.length > 2) {
            result = parts[0] + '.' + parts.slice(1).join('');
          }
        
          // Allow at most two decimal places
          if (parts.length === 2 && parts[1].length > 2) {
          
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
          } else if (parts.length === 2 && parts[1].length <= 2) 
          {
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
          }else
          {
            result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }
          return result ? `$${result}` : '';

      } else 
      {
        return "";
      }
  };


  const formatDecimal = (value) => {

    if (value != null && value !=="")
    {
          value = value.toString();
          // Remove all non-numeric characters except for the decimal point
          let result = value.replace(/[^0-9.]/g, '');
        
          // If there are multiple decimal points, keep only the first one
          const parts = result.split('.');
          if (parts.length > 2) {
            result = parts[0] + '.' + parts.slice(1).join('');
          }
        
          // Allow at most two decimal places
          if (parts.length === 2 && parts[1].length > 2) {
          
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
          } else if (parts.length === 2 && parts[1].length <= 2) 
          {
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
          }else
          {
            result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }
          return result ? `${result}` : '';
  
      } else 
      {
        return "";
      }
  };
  
  
  const formatInteger = (value) => {
  
    if (value != null && value !=="")
    {
          value = value.toString();
          // Remove all non-numeric characters except for the decimal point
          let result = value.replace(/[^0-9]/g, '');
        
          result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          
          return result ? `${result}` : '';
  
      } else 
      {
        return "";
      }
  };


  const getFileExtension = (fileName) => {
    return fileName.split('.').pop().toLowerCase();
  };

  const renderFile = (fileContent,fileName) => {
    if (!fileContent || !fileName) return null;
    const fileType = getFileExtension(fileName);
    if (fileType === 'pdf') {
      return <img src={PdfThumbnail} title={fileName} alt="PDF thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer',height:'100px',width:'81px' }} />;
    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileType)) {
      return <img src={fileContent} title={fileName} alt="Profile thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer', maxWidth: '400px', maxHeight: '400px' }} />;
    } else {
      return <img src={GenericFileThumbnail} title={fileName} alt="File thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer',height:'100px',width:'77px'  }} />;
    }
  };

  const handleFileClick = (fileType,fileContent,fileName) => {
    if (fileType === 'pdf') {
      
      const base64String = fileContent.split(',')[1]; // Extract base64 string from data URL
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
  
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);
  
      window.open(blobUrl, '_blank');

    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileType)) {
      const image = new Image();
      image.src = fileContent;
    
      image.onload = () => {
        let width = image.naturalWidth;
        let height = image.naturalHeight;
        const padding = 50;
    
        // Get browser window dimensions
        const maxWidth = window.innerWidth - padding;
        const maxHeight = window.innerHeight - padding;
    
        // Resize the image if it's larger than the browser window
        if (width > maxWidth || height > maxHeight) {
          const widthRatio = maxWidth / width;
          const heightRatio = maxHeight / height;
          const minRatio = Math.min(widthRatio, heightRatio);
    
          width = Math.floor(width * minRatio);
          height = Math.floor(height * minRatio);
        }
    
        // Calculate the position to center the window
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);
    
        // Open the window with the calculated position and size
        const w = window.open("", "", `width=${width + padding},height=${height + padding},left=${left},top=${top}`);
        image.style.width = `${width}px`;
        image.style.height = `${height}px`;
        w.document.write(image.outerHTML);
      };
        
    } else {
      const link = document.createElement('a');
      link.href = fileContent;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  

    return (
        <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerClose}>
          <div>
          <Box sx={{ width: 600, padding: 2, backgroundColor:colors.drawerModalBackgroundColor, height: '100%', minHeight: '100vh'  }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">

              {handleArrowDownClick ? (
              <Box display="flex">
                <IconButton onClick={handleArrowUpClick}>
                  <KeyboardArrowUpIcon />
                </IconButton>
                <IconButton onClick={handleArrowDownClick}>
                  <KeyboardArrowDownIcon />
                    </IconButton>
                </Box>

              ) : (
                <Box display="flex">
                  &nbsp;
                </Box>
              )}

                <IconButton onClick={handleDrawerClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
              
                {selectedApplicationLifecycleManagement && (
                    <>
                      <h1>{data.id}</h1>
    <Button variant="contained" color="primary" sx={{ float:'right',backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }} onClick={() => handleOpenEdit(selectedApplicationLifecycleManagement.id)}>
        <EditIcon /> &nbsp; EDIT APPLICATIONLIFECYCLEMANAGEMENT
    </Button>
                    
     <Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>PROJECT:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{formatProject(data.projectId)}</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>STATUS:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>

                    <Box
                                key={data.status}
                                sx={{ 
                                    backgroundColor: statusColorMap[data.status], 
                                    borderRadius: '13px', 
                                    padding: '2px 8px', 
                                    display: 'inline-block', 
                                    marginRight: '4px',
                                    marginBottom: '4px',
                                    color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                    fontWeight:'600'  
                                }}
                                >
                                    { data.status ? data.status.toString() : "" }

                                </Box>
                    </Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>ASSOCIATED REQUIREMENTS:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>

                        <Box>
                        {(data.associatedRequirementIds || []).map(id => (
                            <Box
                            key={id}
                            sx={{ 
                                backgroundColor: associatedRequirementIdsColorMap[associatedRequirementIdsMap[id]], 
                                borderRadius: '13px', 
                                padding: '2px 8px', 
                                display: 'inline-block', 
                                marginRight: '4px',
                                marginBottom: '4px',
                                color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                fontWeight:'600' 
                            }}
                            >
                            {associatedRequirementIdsMap[id]}
                            </Box>
                        ))}
                        </Box>
                    </Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>ASSOCIATED TEST CASES:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{formatAssociatedTestCaseIds(data.associatedTestCaseIds)}</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>ASSOCIATED TEST RUNS:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{formatAssociatedTestRunIds(data.associatedTestRunIds)}</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>ASSOCIATED CODE REVIEWS:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{formatAssociatedCodeReviewIds(data.associatedCodeReviewIds)}</Typography>
</Box><hr/>
                    </>
                )}
            </Box>
            </div>
        </Drawer>
    );
};

export default ApplicationLifecycleManagementDrawerModal;
